export const GiftValueEstimate = 'NB: If this gift was given to a group of people, only provide the estimated value of your portion of the gift';


// WEBPACK FOOTER //
// ./app/constants/informationText.js